import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
} from "@/components/ui/sidebar";
import type { ManagerNavigationSection } from "../types";
import { SidebarNavItem } from "../../SidebarNavigation";

type ExpandedNavProps = {
  onSectionOpenChange: (sectionId: string, open: boolean) => void;
  openSectionIds: string[];
  sections: ManagerNavigationSection[];
};

export const ExpandedNav = ({
  onSectionOpenChange,
  openSectionIds,
  sections,
}: ExpandedNavProps) => {
  const { t } = useTranslation();

  return sections.map(({ id, items, labelKey }) => (
    <Collapsible
      key={id}
      open={openSectionIds.includes(id)}
      onOpenChange={open => onSectionOpenChange(id, open)}
      className="group/collapsible"
    >
      <SidebarGroup className="py-0">
        <SidebarGroupLabel
          asChild
          className="h-10 w-full cursor-pointer gap-2 whitespace-nowrap px-3 font-semibold text-neutral-600 text-xs uppercase tracking-wider hover:bg-sidebar-accent"
        >
          <CollapsibleTrigger>
            {t(labelKey)}
            <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
          </CollapsibleTrigger>
        </SidebarGroupLabel>
        <CollapsibleContent className="overflow-hidden data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down">
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map(item => (
                <SidebarNavItem key={item.to} item={item} />
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </CollapsibleContent>
      </SidebarGroup>
    </Collapsible>
  ));
};
